// calculette PTZ

jQuery(function($) {

  // séparateur de milliers
  function sepMill(value) {
    var val = value.toString();
    val = val.replace(' ', '');
    var valChange = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return valChange;
  };
  function sepMillNonBreak(value) {
    var val = value.toString();
    val = val.replace(' ', '');
    var valChange = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
    return valChange;
  };

  $('.sfi--form__input:not(#sfi--calc--zip)').keyup(function() {
    var _this = this;
    // console.log('onkeydown -> %s', trimNumber($(_this).val()));
    setTimeout( function() {
      $(_this).val(sepMill(trimNumber($(_this).val())));
    },0);
  });

  // on enlève les espaces des valeurs pour l'envoi à l'API
  function trimNumber(value) {
    if (value !== undefined) {
      value = value.replace(' ', '');
      return value;
    } else {
      return;
    }
  };

  var adrAPI = 'https://calculette-ptz.selexium-media.fr';


  $('#sfi-calc__formPTZ').submit( function() {
    lpiCalcPTZ();
    return false;
  });


  function lpiCalcPTZ() {
// GA event (ticket #18)
      // gtag('event', 'play', {
      //   'send_to': 'UA-110064220-1',
      //   'event_category': 'Calculette PTZ',
      //   'event_action': 'Validation',
      //   'event_label': 'ok'
      // });

    //loader
    $('.ptz-simu-loader').css("display", "block");
    $('.ptz-simu-error').css("display", "none");


    var inputs = {
      'cp':           $("#sfi--calc--zip").val(),
      'nbPers':       trimNumber($("#sfi--cal--nbPers").val()),
      'revFisc':      trimNumber($("#sfi--calc--revFisc").val()),
      'coutProjet':   trimNumber($("#sfi--calc--coutProjet").val()),
      // 'typeProjet':   $("#sfi--calc--typeProjet").val(),
      'apport':       trimNumber($("#sfi--calc--apport").val()),
      'proprio':      $('input[name=dejaProprietaire]:checked').val()
    };

    if(inputs.cp.length == 0 || inputs.nbPers.length == 0 || inputs.revFisc.length == 0 || inputs.coutProjet.length == 0 || inputs.apport.length == 0){
      var error = "Veuillez compléter tous les champs.";
      $('.sfi-calc--result__msg').html(error);
      $('.ptz-simu-loader').css("display", "none");
      $('.ptz-simu-error').css("display", "block");
      $('.sfi-calc--result__results').hide();
    }
    else{
      var dataStr = 'cp='+inputs.cp+'&nbPers='+inputs.nbPers+'&revFisc='+inputs.revFisc+'&coutProjet='+inputs.coutProjet+'&apport='+inputs.apport+'&proprio='+inputs.proprio;

      //appel API php ici
      $.ajax({
        url: adrAPI,
        crossDomain: true,
        type: "GET",
        data: dataStr,
        success : function(data, textStatus, jqXHR) {
          data = JSON.parse(data);
          //console.log(data);
          $('.ptz-simu-loader').css("display", "none");
          // $('.sfi-calc--result__msg').css("display", "block");
            if(data.error != null){
              $('.sfi-calc--result__msg').html(data.error);
              $('.ptz-simu-loader').css("display", "none");
              $('.sfi-calc--result__msg').css("display", "block");
              $('.sfi-calc--result__results').hide();
            }
            else{
              $('#simu-res-zone').html(data.zone);
              $('#simu-res-nbPers').html(inputs.nbPers);
              $('#simu-res-revFisc').html(sepMillNonBreak(inputs.revFisc)+"&nbsp;€");
              $('#simu-res-coutProjet').html(sepMillNonBreak(inputs.coutProjet)+"&nbsp;€");
              $('#simu-res-travaux').html(sepMillNonBreak(25/100*inputs.coutProjet));
              $('#simu-res-apport').html(sepMillNonBreak(inputs.apport)+"&nbsp;€");

              $('#simu-res-montantMax-neuf').html(sepMillNonBreak(data.neuf.montantMax)+"&nbsp;€");
              $('#simu-res-dureeP1-neuf').html(data.neuf.dureeP1/12+"&nbsp;ans");
              $('#simu-res-mensP1-neuf').html(data.neuf.mensP1+"&nbsp;€");
              $('#simu-res-dureeP2-neuf').html(data.neuf.dureeP2/12+"&nbsp;ans");
              $('#simu-res-mensP2-neuf').html(data.neuf.mensP2+"&nbsp;€");
              $('#simu-res-montantAutres-neuf').html(sepMillNonBreak(data.neuf.montantAutres)+"&nbsp;€");

              $('#simu-res-montantMax-ancien').html(sepMillNonBreak(data.ancien.montantMax)+"&nbsp;€");
              $('#simu-res-dureeP1-ancien').html(data.ancien.dureeP1/12+"&nbsp;ans");
              $('#simu-res-mensP1-ancien').html(data.ancien.mensP1+"&nbsp;€");
              $('#simu-res-dureeP2-ancien').html(data.ancien.dureeP2/12+"&nbsp;ans");
              $('#simu-res-mensP2-ancien').html(data.ancien.mensP2+"&nbsp;€");
              $('#simu-res-montantAutres-ancien').html(sepMillNonBreak(data.ancien.montantAutres)+"&nbsp;€");

              $('#simu-res-montantMax-hlm').html(sepMillNonBreak(data.hlm.montantMax)+"&nbsp;€");
              $('#simu-res-dureeP1-hlm').html(data.hlm.dureeP1/12+"&nbsp;ans");
              $('#simu-res-mensP1-hlm').html(data.hlm.mensP1+"&nbsp;€");
              $('#simu-res-dureeP2-hlm').html(data.hlm.dureeP2/12+"&nbsp;ans");
              $('#simu-res-mensP2-hlm').html(data.hlm.mensP2+"&nbsp;€");
              $('#simu-res-montantAutres-hlm').html(sepMillNonBreak(data.hlm.montantAutres)+"&nbsp;€");

              $('.sfi-calc--result__msg').html("");
              $('.sfi-calc--result__msg').hide();
              $('.ptz-simu-loader').css("display", "none");
              $('.sfi-calc--result__results').show();
              $('.sfi-calc--result').removeClass('no-result error');

              console.log('Calculette PTZ ok');

              gtag('event', 'submit', {
                'send_to' : 'UA-122662450-4',
                'event_category' : 'Calculette PTZ'
              });
            }
            $('.sfi-calc--resultat').css('display', 'block');
            jQuery( document.body ).trigger( 'post-load' );
        },
        error : function(jqXHR, textStatus, errorThrown) {
          $('#simu-res-error').html("Une erreur serveur est survenue, veuillez recommencer ultérieurement.");
          $('.ptz-simu-loader').css("display", "none");
          $('.ptz-simu-error').css("display", "block");
          console.log(':( erreur : %s', textStatus);
          console.log(jqXHR);
        }
      });//end ajax
    }//end tout les champs ok
  }
});//end document ready function

function trimNumber(value) {
  if (value !== undefined) {
    value = value.replace(' ', '');
    return value;
  } else {
    return;
  }
};
